import React from 'react';
import styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const HelpButton = () => {
  const supportLink = 'https://support.alltrails.com/hc/en-us/articles/360019245911-How-do-I-create-a-map-';
  return (
    <a className={styles.button} target="_blank" rel="noreferrer" href={supportLink}>
      {StringConstantsMixin.strings.MAP_CREATOR.NEED_HELP}
    </a>
  );
};

export default HelpButton;
